module.exports = __webpack_public_path__ + "static/kindbio-pct-92a3823ef740ee3306bec1b79b10c65d.svg";